import React from "react";

/**
 * Bootstrap badge. theme prop maps to badge-{theme} class.
 * e.g. <Badge theme="danger">Red</Badge>
 */
const Badge = ({ theme = "primary", pill = false, className = "", style, children, ...rest }) => {
  const cls = ["badge", `badge-${theme}`, pill && "badge-pill", className].filter(Boolean).join(" ");
  return (
    <span className={cls} style={style} {...rest}>
      {children}
    </span>
  );
};

export default Badge;
